"use client";

import React from "react";
import { Clock, CreditCard, Facebook, Instagram, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-[#111111] animate-pulse rounded-none" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-[10px] font-['Montserrat'] text-gray-400 hover:text-[#DC143C] transition-colors uppercase tracking-widest">
            Home
          </Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-[10px] font-['Montserrat'] text-gray-400 hover:text-[#DC143C] transition-colors uppercase tracking-widest">
            Servizi
          </Link>
        </li>
        <li data-index={2}>
          <Link to="#" className="text-[10px] font-['Montserrat'] text-gray-400 hover:text-[#DC143C] transition-colors uppercase tracking-widest">
            Contatti
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-[10px] font-['Montserrat'] text-gray-400 hover:text-[#DC143C] transition-colors uppercase tracking-widest">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function PieDiPagina() {
  return <section data-section-id="139487" id="centro-controllo-logistico" className="bg-[#050505] dark">
      <footer className="border-t border-[#E5E5E5]/20 pt-16 pb-8">
        <div className="container mx-auto px-4 md:px-6 max-w-7xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
            
            {}
            <div className="space-y-6">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591789/img/termoidraulica_km_logo.png" alt="EurLogix Logo" className="h-7 w-auto grayscale brightness-200" />
              <p className="text-gray-400 font-['Montserrat'] text-sm leading-relaxed">
                EurLogix: L'Infrastruttura Invisibile per Dominare l'Est. 
                Ingegnerizziamo la penetrazione commerciale e blindiamo la logistica 
                nei mercati strategici di Russia, Kazakistan e CSI.
              </p>
            </div>

            {}
            <div className="space-y-6">
              <h4 className="text-[#E5E5E5] font-['Cinzel'] font-semibold tracking-widest uppercase text-sm">Navigazione</h4>
              <MenuProvider menu_id="footer_menu">
                <FooterMenuConsumer />
              </MenuProvider>
            </div>

            {}
            <div className="space-y-6">
              <h4 className="text-[#E5E5E5] font-['Cinzel'] font-semibold tracking-widest uppercase text-sm">Operazioni</h4>
              <ul className="space-y-4 text-sm font-['Montserrat'] text-gray-400">
                <li className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-[#DC143C] shrink-0 mt-0.5" />
                  <span>Hub Centrale: Via Goffredo Mameli 66, 62100 Macerata, HQ Eurasia</span>
                </li>
                <li className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-[#DC143C] shrink-0" />
                  <Link to="tel:+393292490479" className="text-[#DC143C] animate-pulse font-bold hover:text-[#E5E5E5] transition-colors">
                    +39 329 249 0479
                  </Link>
                </li>
                <li className="flex items-start gap-3">
                  <Clock className="w-5 h-5 text-[#DC143C] shrink-0 mt-0.5" />
                  <span>Linea Diretta: H24 / 7 (Emergenze Cargo)</span>
                </li>
              </ul>
            </div>

            {}
            <div className="space-y-6">
              <h4 className="text-[#E5E5E5] font-['Cinzel'] font-semibold tracking-widest uppercase text-sm">Sicurezza & Social</h4>
              
              <div className="space-y-6">
                <div>
                  <p className="text-xs font-['Montserrat'] text-gray-500 mb-3 uppercase tracking-wider">Protocolli di pagamento</p>
                  <div className="flex gap-3 items-center">
                    <div className="bg-[#111111] backdrop-blur-md bg-opacity-20 border border-gray-800 p-2 rounded-none">
                      <CreditCard className="w-6 h-6 text-[#E5E5E5]" />
                    </div>
                    <span className="text-[10px] font-['Montserrat'] text-gray-500 uppercase">Transazioni Criptate B2B</span>
                  </div>
                </div>
                
                <div>
                  <p className="text-xs font-['Montserrat'] text-gray-500 mb-3 uppercase tracking-wider">Intelligence Network</p>
                  <div className="flex gap-4">
                    <Link to="#" className="bg-[#111111] p-2 rounded-none text-gray-400 hover:bg-[#DC143C] hover:text-white transition-colors border border-gray-800" aria-label="Facebook">
                      <Facebook className="w-4 h-4" />
                    </Link>
                    <Link to="#" className="bg-[#111111] p-2 rounded-none text-gray-400 hover:bg-[#DC143C] hover:text-white transition-colors border border-gray-800" aria-label="Instagram">
                      <Instagram className="w-4 h-4" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

          </div>

          {}
          <div className="mt-16 pt-8 border-t border-gray-800/50 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] font-['Montserrat'] text-gray-700 uppercase tracking-widest">
            <p>
              &copy; {new Date().getFullYear()} EurLogix. Linea Diretta Operazioni Logistiche (Solo emergenze cargo e sdoganamenti).
            </p>
            <div className="flex gap-4">
              <Link to="#" className="hover:text-[#DC143C] transition-colors">Privacy Protocol</Link>
              <Link to="#" className="hover:text-[#DC143C] transition-colors">Termini Operativi</Link>
            </div>
          </div>
        </div>
      </footer>
    </section>;
}